import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IRunCampaignStepPayload } from '@app-store/slices/campaigns/runCampaignStep'

interface TaskAction extends Action {
    payload: IRunCampaignStepPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.runCampaignStep

function* runCampaignStepSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/notifications/campaigns/run-step/${payload.campaignId}/${payload.stepId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* runCampaignStepSaga(): any {
    yield takeLatest<TaskAction>(onRequest, runCampaignStepSagaTask)
}

export default runCampaignStepSaga
